export const navigationAccesses = [
  "main_dashboard:all",
  "payment:all",
  "salesperson:all",
  "pos:all",
  "catalog:all",
  "order:view",
  "order:action",
  "product_collection:view",
  "product_collection:action",
  "produk:view",
  "produk:action",
  "stock:view",
  "stock:action",
  "reports_list:all",
  "price_monitoring:all",
  "shop_monitoring:all",
  "promotion:all",
  "marketplace_connection:view",
  "marketplace_connection:action",
  "payment_method:all",
  "virtual_bundling:view",
  "virtual_bundling:action",
  "warehouse:action",
  "warehouse:view",
];
